export default () => ({
    data: {},
})
